export default "__VITE_ASSET__YROd5P0P__"